import { render, staticRenderFns } from "./AffiliateStatistic.vue?vue&type=template&id=27acad46&"
import script from "./AffiliateStatistic.vue?vue&type=script&lang=ts&"
export * from "./AffiliateStatistic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports